export const getCoverage = (state, memberGroupKey, benefitKey) => {
    let memberGroup = state.policyData.billGroupData.memberGroups.find(memberGroup => memberGroup.memberGroupKey === memberGroupKey);
    return memberGroup.coverages.find(coverage => coverage.benefitKey === benefitKey);
};